/* eslint-disable */
export default function init(Blockly, profile) {
    Blockly.Arduino.control = {};
    Blockly.Arduino.control_arduino_loop = function() {
        return Blockly.Arduino.statementToCode(this, "DO")
    };
    Blockly.Arduino.control_group = function() {
        return Blockly.Arduino.statementToCode(this, "DO")
    };
    Blockly.Arduino.control_arduino_setup = function() {
        var a = Blockly.Arduino.statementToCode(this, "DO");
        a && (Blockly.Arduino.setups_.arduino_setup = a);
        return null
    };
    Blockly.Arduino.controls_for = function() {
        var a = Blockly.Arduino.nameDB_.getName(this.getFieldValue("VAR"), Blockly.VARIABLE_CATEGORY_NAME),
            b = Blockly.Arduino.valueToCode(this, "FROM", Blockly.Arduino.ORDER_ASSIGNMENT) || "0",
            c = Blockly.Arduino.valueToCode(this, "TO", Blockly.Arduino.ORDER_ASSIGNMENT) || "0",
            d = Blockly.Arduino.valueToCode(this, "BY", Blockly.Arduino.ORDER_ASSIGNMENT) || "0",
            e = Blockly.Arduino.statementToCode(this, "DO");
        Blockly.Arduino.INFINITE_LOOP_TRAP && (e = Blockly.Arduino.INFINITE_LOOP_TRAP.replace(/%1/g,
            "'" + this.id + "'") + e);
        if (b.match(/^-?\d+(\.\d+)?$/) && c.match(/^-?\d+(\.\d+)?$/)) {
            var f = parseFloat(b) <= parseFloat(c);
            f = "for (" + a + " = " + b + "; " + a + (f ? " <= " : " >= ") + c + "; " + a + "=" + a + (f ? "+" : "-") + d + ") {\n" + e + "}\n"
        } else {
            f = "";
            var g = b;
            b.match(/^\w+$/) || b.match(/^-?\d+(\.\d+)?$/) || (g = Blockly.Arduino.nameDB_.getDistinctName(a + "_start", Blockly.VARIABLE_CATEGORY_NAME), f += "int " + g + " = " + b + ";\n");
            b = c;
            c.match(/^\w+$/) || c.match(/^-?\d+(\.\d+)?$/) || (b = Blockly.Arduino.nameDB_.getDistinctName(a + "_end", Blockly.VARIABLE_CATEGORY_NAME),
                f += "int " + b + " = " + c + ";\n");
            f += "for (" + a + " = " + g + ";\n    (" + g + " <= " + b + ") ? " + a + " <= " + b + " : " + a + " >= " + b + ";\n    " + a + " += (" + g + " <= " + b + ") ? +" + d + " : -" + d + ") {\n" + e + "}\n"
        }
        return f
    };
    Blockly.Arduino.controls_repeat_ext = function() {
        var a = Blockly.Arduino.valueToCode(this, "TIMES", Blockly.Arduino.ORDER_ASSIGNMENT) || "0",
            b = Blockly.Arduino.statementToCode(this, "DO");
        Blockly.Arduino.INFINITE_LOOP_TRAP && (b = Blockly.Arduino.INFINITE_LOOP_TRAP.replace(/%1/g, "'" + this.id + "'") + b);
        var c = Blockly.Arduino.nameDB_.getName("count", Blockly.VARIABLE_CATEGORY_NAME);
        return "for (int " + c + " = 0; " + c + " < " + a + "; " + c + "++) {\n" + b + "}\n"
    };
    Blockly.Arduino.controls_whileUntil = function() {
        var a = Blockly.Arduino.valueToCode(this, "BOOL", Blockly.Arduino.ORDER_NONE) || "false",
            b = Blockly.Arduino.statementToCode(this, "DO");
        Blockly.Arduino.INFINITE_LOOP_TRAP && (b = Blockly.Arduino.INFINITE_LOOP_TRAP.replace(/%1/g, "'" + this.id + "'") + b);
        "UNTIL" == this.getFieldValue("MODE") && (a.match(/^\w+$/) || (a = "(" + a + ")"), a = "!" + a);
        return "while (" + a + ") {\n" + b + "}\n"
    };
    Blockly.Arduino.control_wait_whileUntil = function() {
        var a = Blockly.Arduino.valueToCode(this, "CONDITION", Blockly.Arduino.ORDER_ATOMIC) || "0";
        return "WHILE" == this.getFieldValue("MODE") ? "while(" + a + ");\n" : "while(!(" + a + "));\n"
    };
}
